import { Component } from 'react';
import {connect} from 'react-redux';
import PageTitle from '../../common/page-title/index';
import ContactForm from './contact-us-form';
import {getNewContact} from '../../../actions/contacts';
import TextViewer from '../../common/editor/text-viewer';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';

import '../styles.css';

class ContactUs extends Component {
  componentDidMount() {
    this.props.dispatch(getNewContact());
  }

  render() {
    return (
      <div className="contact-us user-inner-container">
        <img src={IgniteUkLogo} alt="Ignite UK" />
        <PageTitle>
          Contact us
        </PageTitle>

        <TextViewer pageSlug='contact-us-pre-login'/>

        <ContactForm enquiries={this.props.enquiries}/>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  enquiries: state.registration.contact.enquiries || []
});

export default connect(mapStateToProps)(ContactUs);
